import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ModBoss } from '@vp/mod-father';
import useSiteData from '../../hooks/useSiteData';
import { OrderDetailsContext } from '../../components/contexts/OrderDetailsContext';
import {
  commonVpDependenciesV1,
  orderInfoV1,
  orderInfoV2,
  profileInfoV1,
} from '../uxModsContracts';
import { PageModsContext } from '../../components/contexts/PageModsContext';
import { DebugModeContext } from '../../components/contexts/DebugModeContext';
import { modfatherTracker as hostTracker } from '../../apis/trackingApi';
import { SourcePageContext } from '../../components/contexts/SourcePageContext';
import useShopperProfile from '../../hooks/useShopperProfile';

/**
 * This component handles injection of mods on the Page & Order Level.
 * Such mods can either be from site configuration, with a 'order' scope or a 'page' scope,
 * or be attached to the `Order` objects via customOrderData.
 *
 * @param {*} children
 */
const DetailsOrderUxModWrapper = ({ children }) => {
  const { modBossLogLevel } = useContext(DebugModeContext);
  const { locale } = useSiteData();
  const { activePageLevelPageUxMods: pageUxMods } = useContext(PageModsContext);
  const { activeOrderLevelPageUxMods: orderUxMods } =
    useContext(PageModsContext);

  const orderDetailsContext = useContext(OrderDetailsContext);

  const profile = useShopperProfile();
  const { order, vistacartTenantName } = orderDetailsContext;

  const libraries = {};

  const environmentData = order
    ? {
        orderInfoV1: orderInfoV1(order, vistacartTenantName),
        orderInfoV2: orderInfoV2(order, vistacartTenantName),
        profileInfoV1: profileInfoV1(
          order.emailAddress || profile?.email || '',
          order.shippingAddress?.phone || ''
        ),
        commonVpDependenciesV1,
      }
    : {};

  const orderAttachedMods = order?.customOrderData?.ux || [];

  const { sourcePage: modHostName } = useContext(SourcePageContext);

  return (
    <ModBoss
      libraries={libraries}
      modHost={modHostName}
      consoleOutputLogLevel={modBossLogLevel}
      locale={locale}
      hostTracker={hostTracker}
    >
      <ModBoss
        mods={[
          ...(pageUxMods || []),
          ...(orderUxMods || []),
          ...(orderAttachedMods || []),
        ]}
        environmentData={environmentData}
      >
        {children}
      </ModBoss>
    </ModBoss>
  );
};

DetailsOrderUxModWrapper.propTypes = {
  children: PropTypes.any,
};

export default DetailsOrderUxModWrapper;
